import { types } from "mobx-state-tree";
import TagModel from "data/models/tag";

export default types
  .model({
    items: types.array(TagModel),
  })
  .actions((self) => ({
    set(values) {
      try {
        self.items = values;
        return self;
      } catch (error) {
        console.log("error", error);
      }
    },

    add(tag) {
      self.items.push(tag);
      return self;
    },

    remove(tagId) {
      self.items = self.items.filter((tag) => tag.id !== tagId);
      return self;
    },

    updateTag(tagId, values) {
      const tag = self.byId(tagId);
      if (tag) tag.update(values);
      return self;
    },
  }))
  .views((self) => ({
    byRoomId(chatRoomId) {
      return self.items.find((tag) => tag.chatRoomId === chatRoomId);
    },
    byId(tagId) {
      return self.items.find((tag) => tag.id === tagId);
    },

    hasTag(tagId) {
      return self.items.some((tag) => tag.id === tagId);
    },
  }));
